import React from "react";
import { TextField } from "@mui/material";
import { autoCapitalizeWords } from "../../../../constants";

/**
 * A lightweight textfield used in ExternalNarratorDataFieldsSection.
 * Unlike QTDetailsTextFieldWithLabelSection, this component does NOT add its
 * own label column or fixed widths, so it aligns cleanly within our 2-column grid.
 *
 * Pass `capitalizeWords` to auto-capitalize the first letter of each word as
 * the user types, while still allowing them to go back and edit to lowercase.
 *
 * `error` / `helperText` / `onBlur` are optional; when omitted the field
 * behaves exactly as before.
 */
const ExternalNarratorTextField = ({
  value,
  onChange,
  multiline = false,
  rows,
  disabled,
  placeholder,
  sx,
  capitalizeWords,
  error,
  helperText,
  onBlur,
  type,
}) => {
  const handleChange = capitalizeWords ? autoCapitalizeWords(onChange) : onChange;

  return (
    <TextField
      fullWidth
      variant="outlined"
      value={value ?? ""}
      onChange={handleChange}
      onBlur={onBlur}
      type={type}
      multiline={multiline}
      rows={rows}
      disabled={!!disabled}
      placeholder={placeholder}
      error={!!error}
      helperText={helperText}
      sx={{
        maxWidth: 420,
        "& .MuiInputBase-input.Mui-disabled": {
          WebkitTextFillColor: "#000000",
        },
        ...sx,
      }}
      InputProps={{
        sx: {
          height: multiline ? undefined : 40,
          backgroundColor: "#D2D2D2",
          color: "#020303",
          fontSize: 14,
          fontWeight: 500,
          fontFamily: "Avenir Book, sans-serif",
        },
      }}
    />
  );
};

export default ExternalNarratorTextField;

